// extracted by mini-css-extract-plugin
export var header = "blogPost-module--header--1hWKQ";
export var hero = "blogPost-module--hero--3Qyhh";
export var heroContent = "blogPost-module--hero-content--2pvJ3";
export var authorSection = "blogPost-module--author-section--1N5Y7";
export var authorImage = "blogPost-module--author-image--3cPIX";
export var center = "blogPost-module--center--3i9_R";
export var nav = "blogPost-module--nav--2Cle9";
export var author = "blogPost-module--author--nqE5Y";
export var arrowAdjust = "blogPost-module--arrow-adjust--3fVIO";